import { Box, Typography, Button, TablePagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { loadingSpace } from "../../assets/styles";

const columns = [
    { id: 'coupon_code', label: 'Coupon Code' },
    { id: 'discount', label: 'Discount %' },
    { id: 'status', label: 'Status' },
    { id: 'action', label: 'Action' },
    { id: 'remove', label: 'Remove' },
];

const CouponsEdit = () => {
    const [codesData, setCodesData] = useState([]);
    const [isLoadingCodesData, setIsLoadingCodesData] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingCodesData(true);
            try {
                const response = await fetch(`https://apivsfintech.invtechnologies.in/couponcodestatus`);
                if (!response.ok) {
                    throw new Error(`HTTP error status: ${response.status}`);
                }
                const result = await response.json();
                setCodesData(result.data.reverse());
            } catch (error) {
                console.error("Error fetching plans data:", error);
            } finally {
                setIsLoadingCodesData(false);
            }
        };
        fetchData();
    }, []);

    const handleCodeToggle = async (code) => {
        try {
            const response = await fetch(`https://apivsfintech.invtechnologies.in/togglecouponactivation/${code.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (!response.ok) {
                throw new Error('Coupon code edit failed');
            } else {
                alert('Coupon code status updated successfully');
                setCodesData(codesData.map(item => item.id === code.id ? { ...item, status: code.status === 0 ? 1 : 0 } : item));
                window.location.reload();
            }
        } catch (error) {
            console.error('Error editing Coupon code:', error.message);
            alert('Something went wrong. Please try again later');
        }
    };

    const handleDelete = async (code) => {
        try {
            const response = await fetch(`https://apivsfintech.invtechnologies.in/deletecouponcode/${code.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (!response.ok) {
                throw new Error('Coupon code delete failed');
            } else {
                alert('Coupon code deleted successfully');
                window.location.reload();
            }
        } catch (error) {
            console.error('Error deleting Coupon code:', error.message);
            alert('Something went wrong. Please try again later');
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Box sx={{ width: "90%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}>
            {isLoadingCodesData ? (
                <Box style={loadingSpace}><CircularProgress /></Box>
            ) : (
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {codesData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                            {columns.map((column) => {
                                                if (column.id === 'action') {
                                                    return (
                                                        <TableCell key={column.id}>
                                                            <Button variant="contained" sx={{ backgroundColor: row.status === 0 ? 'green' : 'orange' }} onClick={() => handleCodeToggle(row)}>
                                                                {row.status === 0 ? "Enable" : "Disable"}
                                                            </Button>
                                                        </TableCell>
                                                    );
                                                } else if (column.id === 'status') {
                                                    return (
                                                        <TableCell key={column.id}>
                                                            <Typography style={{ color: row.status === 1 ? 'green' : 'red' }}>
                                                                {row.status === 1 ? 'Active' : 'Disabled'}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                } else if (column.id === 'remove') {
                                                    return (
                                                        <TableCell key={column.id}>
                                                            <Button variant="contained" color="error" onClick={() => handleDelete(row)}>
                                                                Delete
                                                            </Button>
                                                        </TableCell>
                                                    );
                                                } else {
                                                    let value = row[column.id];
                                                    return (
                                                        <TableCell key={column.id}>
                                                            <Typography>{value}</Typography>
                                                        </TableCell>
                                                    );
                                                }
                                            })}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={codesData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            )}
        </Box>
    );
};
export default CouponsEdit;